"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PropertySearch() {
  const {
    ref: leftRef,
    isVisible: isLeftVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: isRightVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222869" id="property-search" className="relative w-full bg-background overflow-hidden py-24 lg:py-32 xl:py-40">
      {}
      
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8 items-center">
          
          {}
          <div ref={leftRef} className={`lg:col-span-7 flex flex-col gap-8 z-10 transition-all duration-1000 ease-out ${isLeftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] xl:text-[6.5rem] font-bold font-default leading-[1.05] tracking-tighter text-foreground drop-shadow-sm">
              Own Your Future. <br className="hidden md:block" />
              <span className="text-primary">No Banks Required.</span>
            </h1>
            
            <p className="font-default text-lg md:text-xl text-muted-foreground max-w-2xl leading-relaxed">
              Discover owner-financed properties across the country. We bridge the gap between sellers and buyers with flexible private financing options. Your path to homeownership starts here.
            </p>
            
            <div className="flex items-center gap-4 pt-4">
              <Link to="/FindHomePage">
                <Button size="lg" className="h-14 px-8 text-base rounded-lg bg-primary text-primary-foreground shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5 transition-all duration-300">
                  Search Properties
                  <ArrowRight className="ml-2 size-5" />
                </Button>
              </Link>
            </div>
          </div>

          {}
          <div ref={rightRef} className={`lg:col-span-5 relative z-0 transition-all duration-1000 delay-200 ease-out ${isRightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <div className="relative w-full max-w-md mx-auto lg:ml-auto aspect-[4/5] lg:aspect-[3/4]">
              
              {}
              <div className="absolute inset-0 bg-accent rounded-2xl transform rotate-3 scale-105 transition-transform duration-1000 hover:rotate-6 shadow-inner"></div>
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/texas_ranch_hero.png" alt="Modern Home Property" className="absolute inset-0 w-full h-full object-cover rounded-lg shadow-2xl shadow-primary/10 z-10 transition-transform duration-700 hover:scale-[1.02]" />
              
              {}
              <div className="absolute -bottom-8 -left-8 w-44 aspect-square z-20">
                <div className="relative w-full h-full">
                  <div className="absolute inset-0 bg-background/20 rounded-lg blur-md transform translate-y-4"></div>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1686519/img/property_detail_interior.png" alt="Luxury Interior Detail" className="relative w-full h-full object-cover rounded-lg shadow-xl border border-border/50 transition-transform duration-500 hover:-translate-y-2" />
                </div>
              </div>

              {}
              <div className="absolute top-12 -right-6 z-30 bg-background/80 backdrop-blur-md px-6 py-4 rounded-lg shadow-xl border border-border/50 animate-pulse" style={{
              animationDuration: '4s'
            }}>
                <div className="flex items-center gap-3">
                  <div className="size-2 rounded-lg bg-primary animate-ping"></div>
                  <p className="font-mono text-sm font-medium text-foreground">Private Financing</p>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </section>;
}